import styled from '@/styles';
import type { SegmentTone } from '../onboardingMappings';

const Bar = styled('div', {
  display: 'flex',
  gap: '4px',
  marginTop: '6px',
  width: '150px',
  maxWidth: '100%',
});

const Segment = styled('span', {
  flex: '1 1 0',
  height: '4px',
  borderRadius: '2px',
  variants: {
    tone: {
      done: { backgroundColor: '#44A735' },
      current: { backgroundColor: '#E8A33D' },
      rejected: { backgroundColor: '#C62828' },
      todo: { backgroundColor: '#DADADA' },
    },
  },
});

type Props = { segments: SegmentTone[]; testId?: string };

// Decorative: the text beside every bar ("Step 4 of 6: I-9 form", "Pending")
// carries the state, so colour is never the only signal (ticket WL-10).
const SegmentBar = ({ segments, testId }: Props) => (
  <Bar aria-hidden="true" data-testid={testId}>
    {segments.map((tone, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Segment key={i} tone={tone} data-tone={tone} />
    ))}
  </Bar>
);

export default SegmentBar;
